document.addEventListener('DOMContentLoaded', function() {
  const trigger = document.querySelector('[data-size-guide-trigger]');
  const modal = document.querySelector('[data-size-guide-modal]');
  const closeButtons = document.querySelectorAll('[data-size-guide-close]');

  if (trigger && modal) {
    // 打开弹窗
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      modal.classList.add('active');
      modal.style.display = 'flex'; 
      document.body.style.overflow = 'hidden';
    });

    // 关闭弹窗
    closeButtons.forEach(button => {
      button.addEventListener('click', function() {
        modal.classList.remove('active');
        modal.style.display = 'none';
        document.body.style.overflow = '';
      });
    });

    // 按 ESC 键关闭
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        modal.classList.remove('active');
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  }
});